module.exports = __webpack_public_path__ + "img/car-app.3ea306d.png";